export const parse = value => parseInt(value, 10);